import { Link } from "react-router-dom";
import { Logo } from "@/components/Shared";

const SECTIONS = [
  ["What we collect", "Your name, email, phone, craft and hire date; the daily field reports you file (project, hours, crew, quantities, comments, safety notes and jobsite photos); and your timesheets (dates, locations, miles, ATV use, hours and minutes). We also record sign-in times and a log of changes made to reports, timesheets and accounts."],
  ["Why we collect it", "To run QDB Consulting's projects: reporting work to clients, keeping project records, and processing payroll and mileage."],
  ["Who can see it", "You can see your own reports and timesheets. QDB Consulting admins can see everyone's records. Daily report summaries may be emailed to the recipients the company sets up. We do not sell your information, and the portal has no advertising trackers or session recording."],
  ["Services we use", "The portal is hosted on Emergent's platform. Photos are stored in secure cloud storage, and emails are sent through Resend."],
  ["How long we keep it", "[Retention period: to be confirmed by QDB Consulting, e.g. as long as required for payroll and client records]."],
  ["Security", "Passwords are stored encrypted (hashed) and never shown. Access is limited by role, sessions end when you sign out or change your password, and submitted timesheets are locked. Any admin unlock is recorded with a reason."],
  ["Questions or corrections", "If something in your records is wrong or you have questions, contact [privacy contact name and email]."],
];

export default function Privacy() {
  return (
    <main className="mx-auto max-w-2xl px-5 py-10" data-testid="privacy-page">
      <Logo className="h-12" />
      <h1 className="mt-6 font-display text-4xl font-semibold text-slate-900">Employee privacy notice</h1>
      <p className="mt-2 text-sm text-slate-600">QDB Consulting LLC field reporting portal · Last updated October 16, 2026</p>
      <div className="mt-8 space-y-6">
        {SECTIONS.map(([h, t]) => (
          <section key={h}>
            <h2 className="text-lg font-semibold text-slate-900">{h}</h2>
            <p className="mt-1 text-base leading-relaxed text-slate-700">{t}</p>
          </section>
        ))}
      </div>
      <Link to="/" className="btn-ghost mt-10 inline-flex h-12 px-5" data-testid="privacy-back-link">Back to the portal</Link>
    </main>
  );
}
